import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAnimateNumber from "vue-animate-number";
import {
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Pagination,
  Select,
  Option,
  Input,
  Tooltip,
  Empty,
  Checkbox,
  Badge,
  Progress,
  DatePicker,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Message,
  Upload,
  Dialog,
  Button,
  MessageBox,
  Link,
  Autocomplete,
} from "element-ui";

// 语言切换
import i18n from "./lang";

import "@/icons";

// 路由处理
import "./permission";

// 公共样式
import "@/assets/css/common.css";

Vue.config.productionTip = false;

Vue.use(VueAnimateNumber)
  .use(Table)
  .use(TableColumn)
  .use(Tabs)
  .use(TabPane)
  .use(Pagination)
  .use(Select)
  .use(Option)
  .use(Input)
  .use(Tooltip)
  .use(Empty)
  .use(Checkbox)
  .use(Badge)
  .use(Progress)
  .use(DatePicker)
  .use(Dropdown)
  .use(DropdownItem)
  .use(DropdownMenu)
  .use(Upload)
  .use(Dialog)
  .use(Button)
  .use(Link)
  .use(Autocomplete);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$Url = process.env.VUE_APP_SERVER + "/images/avatar/";

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
